const conditions = () => {
  return []
}

export default conditions
